import { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import { Box, CircularProgress, Typography } from "@mui/material";

import { useParamsContext } from "../../contexts/params/ParamsContext";
import {
  resolveRedirectURL,
  validateUrlParameters,
} from "../Login/LoginDefault/context/utilsLoginContext";

/**
 * Landing page for the Microsoft ("Login Corporativo") flow.
 *
 * The gateway sets the `accessToken` / `refreshToken` cookies on the shared
 * parent domain before redirecting here, so no token is read from the URL. This
 * page only confirms the session cookie is present and forwards the user to the
 * originally requested application (honoring the round-tripped `url` param,
 * identical to the password login flow).
 */
export const MicrosoftCallbackPage: React.FC = () => {
  const { params } = useParamsContext();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const cookies = new Cookies();
    const accessToken = cookies.get("accessToken");

    if (!accessToken) {
      setError(
        "Não foi possível concluir o login corporativo. Tente novamente."
      );
      return;
    }

    try {
      const { redirectURL, redirectPath } = validateUrlParameters(params);
      const finalURL = resolveRedirectURL(redirectURL, null, redirectPath);
      document.location.href = finalURL;
    } catch (err) {
      setError(
        (err as Error).message ||
          "Não foi possível determinar a URL de redirecionamento."
      );
    }
  }, [params]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 3,
      }}
    >
      {error ? (
        <Typography color="error" sx={{ fontSize: "1.6rem", textAlign: "center", px: 4 }}>
          {error}
        </Typography>
      ) : (
        <>
          <CircularProgress />
          <Typography sx={{ fontSize: "1.6rem" }}>
            Concluindo login corporativo...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default MicrosoftCallbackPage;
